import React, { Component } from "react";
import {
  getProductCategoryListRequest,
  updateProductCategoryStatusByProductCategoryIdRequest,
  deleteProductCategoryByProductCategoryIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeProductCategorySelectField } from "store/Masters/ProductCategory/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Sequence",
    field: "productCategorySeq",
  },
  {
    label: "Product Category Name",
    field: "productCategoryName",
  },
  {
    label: "Category Name",
    field: "categoryName",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class ProductCategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productCategoryRecords: [],
    };
  }

  componentDidMount() {
    //Retrieve productCategory list
    this.props.getProductCategoryListRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateProductCategoryStatusByProductCategoryIdRequest(
      id,
      checked
    );
  };

  buildProductCategoryDataTable = (records) => {
    this.setState({
      productCategoryRecords: records.map((productCategory) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewProductCategory(productCategory)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteProductCategory(
                productCategory.productCategoryId
              )}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={productCategory.productCategoryId + ""}
              checked={productCategory.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          productCategorySeq: productCategory.productCategorySeq,
          categoryName: productCategory.categoryName,
          productCategoryName: productCategory.productCategoryName,
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.productCategoryData !== nextprops.productCategoryData) {
      this.buildProductCategoryDataTable(nextprops.productCategoryData);
    }
  }

  viewProductCategory = (productCategoryData) => () => {
    this.props.onViewProductCategory(productCategoryData);
  };

  deleteProductCategory = (productCategoryId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteProductCategoryByProductCategoryIdRequest(
        productCategoryId
      );
    }
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.productCategoryRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productCategoryData: makeProductCategorySelectField("productCategoryData"),
});

const withConnect = connect(mapStatetoProps, {
  getProductCategoryListRequest,
  updateProductCategoryStatusByProductCategoryIdRequest,
  deleteProductCategoryByProductCategoryIdRequest,
});

export default compose(withConnect, withRouter)(ProductCategoryList);
